import {useState} from "react";

const useInput = (initialValue, validateValue) => {

    const [enteredValue, setEnteredValue] = useState(initialValue || '');
    const [isTouched, setIsTouched] = useState(false);

    const valueIsValid = validateValue ? validateValue(enteredValue) && isTouched : isTouched;

    const valueChangeHandler = (event) => {
        setEnteredValue(event.target.value);
        setIsTouched(true);
    }

    const explicitSet = (value) => {
        setEnteredValue(value);
        setIsTouched(true);
    }

    const reset = () => {
        setEnteredValue('');
        setIsTouched(false);
    }

    return {
        value: enteredValue,
        touched: isTouched,
        isValid: valueIsValid,
        explicitSet,
        valueChangeHandler,
        reset
    }

}

export default useInput;